/**
 * 环境判定(TAPD 1006913 新增,仓库原来没有 UA 工具)
 *
 * 只做"打开 App"分层跳转需要的三件判断,不做浏览器版本嗅探。
 */
const ua = () => (typeof navigator !== 'undefined' && navigator.userAgent ? navigator.userAgent.toLowerCase() : '')

// 微信内置浏览器。注意企业微信(wxwork)也含 micromessenger,一并算微信内 ——
// 它同样禁 scheme 跳转,引导文案一致。
export const isWeixin = () => /micromessenger/.test(ua())

export const isIOS = () => /iphone|ipad|ipod/.test(ua())

export const isAndroid = () => /android|adr/.test(ua())



// WEBPACK FOOTER //
// ./src/utils/ua.js